import api from './api';

const createMemberSurvey = query => api.post('/api/member-surveys/', { ...query });

export default {
  createMemberSurvey,
};
